<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 44.084 18.105">
    <g id="Wagon" transform="translate(0)">
      <path id="Path_86884" data-name="Path 86884"
        d="M1634.638,74.31a4.019,4.019,0,1,0-4.019-4.018,4.023,4.023,0,0,0,4.019,4.018m0-6.219a2.2,2.2,0,1,1-2.2,2.2,2.2,2.2,0,0,1,2.2-2.2"
        transform="translate(-1597.878 -56.205)" :fill="themeColor" />
      <path id="Path_86885" data-name="Path 86885"
        d="M1821.708,74.31a4.019,4.019,0,1,0-4.018-4.018,4.023,4.023,0,0,0,4.018,4.018m0-6.219a2.2,2.2,0,1,1-2.2,2.2,2.2,2.2,0,0,1,2.2-2.2"
        transform="translate(-1814.304 -56.205)" :fill="themeColor" />
      <path id="Path_86886" data-name="Path 86886"
        d="M1610.934,16.9a.9.9,0,0,0,.386-.086.91.91,0,0,0,.437-1.209,6,6,0,0,1-.176-3.764l1.065-1.584a.943.943,0,0,0,.139-.336c.266-1.381,1.454-5.325,3.344-5.325a.862.862,0,0,0,.132-.01c.114-.016,11.4-1.644,17.022.327,1.685.592,4.081,1.759,6,2.7,1.009.491,1.906.929,2.548,1.211a20.486,20.486,0,0,0,3.464.948,15.461,15.461,0,0,1,4.52,1.414c1.038.73,1.787,3.418,2.016,4.941a.909.909,0,0,0,1.8-.268c-.072-.482-.76-4.747-2.769-6.16a15.843,15.843,0,0,0-5.177-1.7,19.7,19.7,0,0,1-3.121-.836c-.626-.275-1.5-.7-2.483-1.18a67.166,67.166,0,0,0-6.2-2.778c-5.877-2.065-16.8-.566-17.828-.419-3.437.072-4.761,5.386-5.021,6.612l-1.072,1.594a.907.907,0,0,0-.14.346,7.922,7.922,0,0,0,.287,5.045.909.909,0,0,0,.824.523"
        transform="translate(-1609.559 -2.116)" :fill="themeColor" />
      <path id="Path_86887" data-name="Path 86887"
        d="M1691.328,86.552H1708.2a.909.909,0,1,0,0-1.818h-16.875a.909.909,0,1,0,0,1.818"
        transform="translate(-1677.717 -71.769)" :fill="themeColor" />
      <path id="Path_86888" data-name="Path 86888"
        d="M1694.714,38.018a.909.909,0,0,0,0-1.818l-26.747-.116h0a.909.909,0,0,0,0,1.818l26.747.116Z"
        transform="translate(-1660.562 -30.754)" :fill="themeColor" />
    </g>
  </svg>

</template>

<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
